module.exports = __webpack_public_path__ + "static/media/fileIcon.7b3e39b8.svg";